import React, { MouseEventHandler } from 'react';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Color } from '~common/model/basics';
import { getIconColor } from '~web/view/components/ui/icon.helper';

export interface IconProps {
  width?: number;
  height?: number;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
  color?: string | Color;
  className?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
  transform?: string;
}

export const Icon: React.FunctionComponent<IconProps> = ({
  viewBoxWidth,
  viewBoxHeight,
  width,
  height,
  color = Color.White,
  className,
  onClick,
  children,
  transform,
}) => (
  <Svg
    className={className}
    width={width}
    height={height}
    fill={getIconColor(color)}
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    onClick={onClick}
    transform={transform}
  >
    {children}
  </Svg>
);

const Svg = styled(({ transform, ...rest }) => <svg {...rest} />)<{
  onClick?: MouseEventHandler;
  transform: string;
}>`
  flex: none;
  ${(props): FlattenSimpleInterpolation | null =>
    props.onClick &&
    css`
      cursor: pointer;
    `};
  ${(props): FlattenSimpleInterpolation | null =>
    props.transform &&
    css`
      transform: ${props.transform};
    `};
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon.component.tsx